module.exports = __webpack_public_path__ + "static/media/facebook.170c01a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/facebook.svg
// module id = 249
// module chunks = 0